import { uniqueArray } from '../../utilities'

export const handleAddSurvey = (state, action) => {
  const { id, survey } = action

  const oldSurveys = state.surveys[id] ?? []
  const alreadyAdded = oldSurveys.some(oldSurvey => oldSurvey.id === survey.id)
  if (alreadyAdded) {
    return state
  }

  return {
    ...state,
    surveys: {
      ...state.surveys,
      [id]: [...oldSurveys, survey]
    },
    updated: uniqueArray([...state.updated, id])
  }
}

export const handleClearUpdate = (state, action) => {
  const { id: clearId } = action

  const newUpdated = state.updated.filter(id => id !== clearId)

  return {
    ...state,
    updated: newUpdated
  }
}

export const initialState = {
  surveys: {}, // Key will be session id, value is array of surveys
  updated: [] // Array of session ids that have updates
}

export const Actions = {
  ADD_SURVEY: 'ADD_SURVEY',
  CLEAR_UPDATE: 'CLEAR_UPDATE'
}

const Handlers = {
  [Actions.ADD_SURVEY]: handleAddSurvey,
  [Actions.CLEAR_UPDATE]: handleClearUpdate
}

export const surveyReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown survey reducer type: ${type}`)
}
